import React from "react";
import { CardFlip } from "../../CardFlip/CardFlip";
import {
  CardTechnologiesFront,
  TCardTechnologiesFront
} from "../CardTechnologiesFront/CardTechnologiesFront";

import "./cardTechnologies.scss";

export const CardTechnologies = ({
  image,
  name
}: TCardTechnologiesFront): JSX.Element => {
  return (
    <CardFlip
      className='card-technologies my-4'
      cardFlipFront={<CardTechnologiesFront image={image} name={name} />}
      cardFlipBack={<CardTechnologiesFront image={image} name={name} />}
    />
  );
};
